import React from 'react';

const Logo = React.createClass({
    propTypes: {
        children: React.PropTypes.node.isRequired,
        icon: React.PropTypes.string,
        click: React.PropTypes.func
    },
    render: function() {
        return (
            <button onClick={this.props.click}>
                {this.props.icon ? (
                    <img src={this.props.icon} alt={this.props.children} />
                ) : null}
                {this.props.children}
            </button>
        );
    }
});

export default Logo;



// WEBPACK FOOTER //
// ./src/js/components/Button.js